import { render, staticRenderFns } from "./NationalityComponent.vue?vue&type=template&id=f3fee00c"
import script from "./NationalityComponent.vue?vue&type=script&lang=js"
export * from "./NationalityComponent.vue?vue&type=script&lang=js"
import style0 from "./NationalityComponent.vue?vue&type=style&index=0&id=f3fee00c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports